<template>
  <section class="py-3" v-if="service">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-12">
        <div class="rounded bg-service" :style="$mq.phone ? 'height:220px' : 'height:240px'" v-lazy:background-image="(service.partner_picture) ? service.partner_picture : service.picture"></div>
        <div class="pt-3">
          <img src="/static/img/main-logo.svg" alt="" width="140">
          <div class="my-2">
            <div class="title">{{ service | multiLangName }}</div>
          </div>
        </div>
        <div class="main-content" v-html="(currentLanguage === 'th') ? service.detail_th : service.detail_en"></div>
      </div>
    </div>
    <div class="footer py-3 bg-white">
      <div class="row">
        <div class="col-lg-6 offset-lg-3 col-12">
          <router-link :to="bookingUrl"
                       class="btn btn-info btn-lg btn-block">จองบริการ</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        bookingUrl: null,
        ref: this.$route.query.ref,
        currentLanguage: this.$i18n.locale,
        serviceId: Number(this.$route.params.id),
        service: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    watch: {
      'globalState.services': function () {
        this.service = this.getService(this.serviceId)
      }
    },
    methods: {
      getService (serviceId) {
        if (this.globalState.services) {
          for (const key in this.globalState.services) {
            const service = this.globalState.services[key]
            if (serviceId === service.id) {
              return service
            }
          }
        }
      }
    },
    mounted () {
      this.service = this.getService(this.serviceId)
      this.bookingUrl = `/chat-booking?ref=${this.ref}&is_partner=1&service_id=${this.serviceId}`
    }
  }
</script>

<style scoped>
  .title {
    font-size: 140%;
    font-weight: 400;
  }

  .bg-service {
    background-size: cover;
    background-position: center;
    height: 220px;
  }

  .main-content {
    padding-bottom: 50px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  div >>> ul {
    padding-left: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/ServiceDetail.vue